angular
    .module('ustreet-app')
    .controller('ReportCtrl', ['$scope', function ($scope) {
    $scope.hasRole = app.hasRole;
}]);
